import React from 'react';
export function HookSection() {
  return <section className="bg-gradient-to-b from-[#0a0a0a] via-[#120000] to-[#0a0a0a] py-[34px] px-5" data-id="element-95">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-96">
        <p className="text-[1.05rem] leading-[1.65] text-brand-gray-text mb-3 text-left" data-id="element-97">
          Hay una conversación que ningún hombre quiere tener. Ni con su médico.
          Ni con sus amigos. Ni siquiera consigo mismo. Pero esa conversación
          vive en tu cabeza{' '}
          <strong className="text-brand-white font-semibold" data-id="element-98">
            cada vez que la intimidad se acerca...
          </strong>
        </p>
        <div className="border-l-[4px] border-brand-red bg-[#150000] py-3 px-[20px] my-[16px] rounded-r-[8px]" data-id="element-99">
          <p className="text-[1rem] italic text-[#ddd] leading-[1.6]" data-id="element-100">
            "¿Y si termino antes de tiempo otra vez?"
            <br data-id="element-101" />
            "¿Qué pensará ella si no puedo controlarme?"
            <br data-id="element-102" />
            "Estoy perdiendo la confianza que alguna vez tuve."
          </p>
        </div>
        <p className="text-[1.05rem] leading-[1.65] text-brand-gray-text mb-3 text-left" data-id="element-103">
          Si alguna de esas frases resonó en tu mente, no estás solo. Más del{' '}
          <strong className="text-brand-white font-semibold" data-id="element-104">
            31% de los hombres
          </strong>{' '}
          enfrenta este problema en silencio. El error está en creer que es un
          defecto permanente.
          <strong className="text-brand-white font-semibold" data-id="element-105">
            No lo es.
          </strong>{' '}
          Es un problema de entrenamiento — y todo problema de entrenamiento
          tiene solución.
        </p>
        <p className="text-[1.05rem] leading-[1.65] text-brand-gray-text mb-8 text-left" data-id="element-106">
          El{' '}
          <strong className="text-brand-white font-semibold" data-id="element-107">
            Sistema El Código del Control
          </strong>{' '}
          es el método científico que entrena el músculo exacto que controla tu
          rendimiento, elimina la ansiedad que lo sabotea, y te convierte —
          <strong className="text-brand-white font-semibold" data-id="element-108">en 30 días</strong>{' '}
          — en un hombre completamente diferente dentro y fuera de la cama.
        </p>

        {/* Carousel */}
        <div className="relative w-full overflow-hidden rounded-xl mt-6" data-id="element-109">
          {/* Gradient masks for smooth edges */}
          <div className="absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10 pointer-events-none" data-id="element-110"></div>
          <div className="absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10 pointer-events-none" data-id="element-111"></div>

          <div className="flex w-[200%] animate-marquee" data-id="element-112">
            {/* First set */}
            <div className="flex w-1/2 justify-around items-center gap-4 px-2" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/vmCSHteQ34Em8R5pm3yWhX/hacela_en_otra_locacion_sacale_202605072051.jpg" alt="El Código del Control" className="w-1/3 object-cover rounded-lg shadow-lg aspect-square" data-id="element-114" />
              <img src="https://cdn.magicpatterns.com/uploads/gC4yzcckiGFpJJwUigavaP/arriba_de_una_cama_haceme_202605072041.jpg" alt="El Código del Control" className="w-1/3 object-cover rounded-lg shadow-lg aspect-square" data-id="element-115" />
              <img src="https://cdn.magicpatterns.com/uploads/o7FYyGuTTiuJhfoW8DMS88/Hombre_latino_de_aproximadamente_55_202605051532.jpg" alt="El Código del Control" className="w-1/3 object-cover rounded-lg shadow-lg aspect-square" data-id="element-116" />
            </div>
            {/* Duplicated set for seamless loop */}
            <div className="flex w-1/2 justify-around items-center gap-4 px-2" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/vmCSHteQ34Em8R5pm3yWhX/hacela_en_otra_locacion_sacale_202605072051.jpg" alt="El Código del Control" className="w-1/3 object-cover rounded-lg shadow-lg aspect-square" data-id="element-118" />
              <img src="https://cdn.magicpatterns.com/uploads/gC4yzcckiGFpJJwUigavaP/arriba_de_una_cama_haceme_202605072041.jpg" alt="El Código del Control" className="w-1/3 object-cover rounded-lg shadow-lg aspect-square" data-id="element-119" />
              <img src="https://cdn.magicpatterns.com/uploads/o7FYyGuTTiuJhfoW8DMS88/Hombre_latino_de_aproximadamente_55_202605051532.jpg" alt="El Código del Control" className="w-1/3 object-cover rounded-lg shadow-lg aspect-square" data-id="element-120" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}